// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__Mw3uO","open":"Nav_open__8isos","logo":"Nav_logo__VNYUf","links":"Nav_links__jQQYc"};